import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocation } from '@remix-run/react';
import { useEffect, useRef } from 'react';
export default function LosseBodyScripts(props) {
    const location = useLocation();
    const didMount = useRef(false);
    useEffect(() => {
        if (!props.gtm) {
            return;
        }
        if (didMount.current) {
            if (window.dataLayer) {
                window.dataLayer.push({ event: 'pageview' });
            }
            if (window.ga && window.ga.getAll) {
                const trackers = window.ga.getAll();
                if (trackers.length > 0) {
                    const tracker = trackers[0];
                    tracker.set('page', `${location.pathname}${location.search}`);
                    tracker.send('pageview');
                }
            }
        }
        else {
            didMount.current = true;
        }
    }, [location]);
    return (_jsx(_Fragment, { children: props.gtm && (_jsx("noscript", { dangerouslySetInnerHTML: {
                __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${props.gtm.id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
            } }, "gtm")) }));
}
